module.exports = __webpack_public_path__ + "img/1920_news_sub_img5.c6401791.png";